import React, {Component} from 'react'
import { SliderStyle, SlideStyle } from './../styles'
import {FlickitySlider} from './'
export default class Slider extends Component {
  constructor(props){
    super(props)
    this.slides = []
  }

  state = {
    active : 0,
  }

  componentDidMount() {
    document.body.style.height = `${this.slides[0].querySelector('.template-scroll').offsetHeight}px`
  }

  componentWillReceiveProps({active}) {
    if (active !== this.state.active){
      this.setState({ active: active}, () => {
        document.body.style.height = `${this.slides[active].querySelector('.template-scroll').offsetHeight}px`
      })
    }
  }

  componentWillUnmount() {
    document.body.setAttribute('style', '')
  }

  next = () => {
    this.setState({ active: this.state.active < this.props.max - 1 ? this.state.active + 1 : 0})
  }

  prev = () => {
    this.setState({ active: this.state.active > 0 ? this.state.active - 1 : this.props.max})
  }

  render(){
    const {children} = this.props

    return (
      <div className={`${SliderStyle}`}>
        <FlickitySlider>
          {
            children
          }
          {/* {
            React.Children.map(children, (child, i) => (
              <div ref={(slide) => this.slides.push(slide) } className={`slider--iterm ${SlideStyle(i === this.state.active)}`} key={i}>
                { child }
              </div>
            ))
          } */}
        </FlickitySlider>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Slider.js